<template>
  <div>
    <div>
      <div class="font-weight-bold" v-if="imageFilesExist">Images</div>
      <v-card v-for="file in imageFileList" :key="file.fileId" class="mb-3">
        <v-img v-if="file.type === `image`" :src="`/api/file?key=${file.filename}`"></v-img>
        <v-card-subtitle> {{ file.originalFilename }} </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <delete-dialog :record="file"></delete-dialog>
          <v-btn text small @click="insertFile(file)">Insert</v-btn>
        </v-card-actions>
      </v-card>
      <div class="font-weight-bold" v-if="otherFilesExist">Files</div>
      <v-card v-for="file in otherFileList" :key="file.fileId" class="mb-3">
        <v-card-subtitle> {{ file.originalFilename }} </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <delete-dialog :record="file"></delete-dialog>
          <v-btn text small @click="insertFile(file)">Insert</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
const { isEmpty } = require("lodash");
import DeleteDialog from "./AttachmentDeleteDialog";

export default {
  name: "attachments",
  components: {
    DeleteDialog,
  },
  computed: {
    fileList() {
      return this.$store.state.file.fileList;
    },
    imageFileList() {
      return this.fileList.filter(file => file.type === "image");
    },
    imageFilesExist() {
      return !isEmpty(this.imageFileList);
    },
    otherFileList() {
      return this.fileList.filter(file => file.type !== "image");
    },
    otherFilesExist() {
      return !isEmpty(this.otherFileList);
    },
  },
  methods: {
    insertFile(file) {
      this.$emit("insertFile", file);
    },
  },
};
</script>
